import * as React from "react";

type InputProps = React.ComponentProps<"input"> & {
  leftIcon?: React.ReactNode;
};

function Input({ className, type, leftIcon, ...props }: InputProps) {
  return (
    <div className="relative flex items-center">
      {leftIcon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
          {leftIcon}
        </span>
      )}
      <input
        type={type}
        data-slot="input"
        className={`
          w-full rounded-xl bg-white/80 dark:bg-zinc-900/80 px-10 py-3 text-base shadow-sm border-2 transition-colors
          placeholder:text-zinc-500 dark:placeholder:text-zinc-300
          focus:outline-none cursor-pointer
          ${
            props["aria-invalid"]
              ? "border-red-500"
              : "border-gray-300 dark:border-zinc-700 focus:border-primary dark:focus:border-primary"
          }
          ${className ?? ""}
        `}
        {...props}
      />
    </div>
  );
}

export { Input };
